export enum HeaderElementInputSizes {
	'h1' = 'h1',
	'h2' = 'h2',
	'h3' = 'h3',
	'h4' = 'h4',
	'label' = 'label'
}

export interface HeaderElementInput {
	label: string;
	description?: string;
	size: HeaderElementInputSizes;
	additionalClasses?: string;
	dry?: boolean;
}

export const HEADER_ELEMENT_DEFAULT_INPUT: HeaderElementInput = {
	label: '',
	description: null,
	size: HeaderElementInputSizes.h2,
	dry: true
};
